import { render, staticRenderFns } from "./QuoteGenButton.vue?vue&type=template&id=06ea30e3&scoped=true"
import script from "./QuoteGenButton.vue?vue&type=script&lang=js"
export * from "./QuoteGenButton.vue?vue&type=script&lang=js"
import style0 from "./QuoteGenButton.vue?vue&type=style&index=0&id=06ea30e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea30e3",
  null
  
)

export default component.exports